<template>
	<div class="scaner-wrapper">
		<div class="setting-row gui-row">
			<div class="full-cell" v-if="!showCamera">
				<select class="rc-form-select full-width" v-model="deviceId">
					<option v-for="device in devicesList" :value="device.id">{{ device.label }}</option>
				</select>
			</div>
			<div class="full-cell" v-if="!showCamera">
				<button class="rc-btn full-width" @click="startCamera">
					Начать сканирование
				</button>
			</div>
			<div class="full-cell" v-if="showCamera">
				<button class="rc-btn full-width" @click="stopCamera">
					Остановить
				</button>
			</div>
		</div>
		<div class="camera-row">
			<div id="qr-code-full-region"></div>
		</div>
		<div class="result-row" v-if="readedCode">
			<div class="result-wrapper">
				<div class="gui-row">
					<div class="middle-cell">
						<p>{{ resultScanFind }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
	
<script>
import store from "@/store"
import { Html5Qrcode } from "html5-qrcode"
import soundScanner from '@/assets/sound_scanner.mp3'

export default {
	name: 'qrcode-scanner',
	components: {
	},
	props: {
		scanFind: {
			type: Boolean,
			default: null
		},
		serverMode: {
			type: Number
		}
	},
	data() {
		return {
			html5QrCode: null,
			deviceId: null,
			devicesList: [],
			readedCode: '',
			readedTs: null,
			showCamera: false,
			sound: new Audio(soundScanner)
		}
	},
	async mounted() {
		await Html5Qrcode.getCameras().then(devices => {
			if (devices && devices.length) {
				this.deviceId = store.state.last_camera_id || devices[0].id
				devices.forEach(device => this.devicesList.push({ id: device.id, label: device.label }))
			}
		})
		store.dispatch('errorProcessing', this.devicesList)
	},
	computed: {
		currentDevice() {
			if (this.deviceId) {
				store.commit('setLastCameraId', this.deviceId)
				const device = this.devicesList.find(dev => dev.id === this.deviceId)
				return { id: device.id, label: device.label }
			}
			return null
		},
		resultScanFind() {
			return `${this.readedCode}: прочитан`
		}
	},
	async beforeUnmount() {
		if (this.showCamera) {
			await this.stopCamera()
		}
	},
	methods: {
		startCamera() {
			this.html5QrCode = new Html5Qrcode('qr-code-full-region')
			this.html5QrCode.start(
				// идентификатор выбранной камеры
				this.currentDevice.id,
				// настройки, см документацию плагина
				{
					fps: 10,
					qrbox: { width: 250, height: 250 }
				},
				// функци обработки результата
				(decodedText, decodedResult) => {
					if (Date.now() - this.readedTs > 5000 || this.readedCode !== decodedText) {
						this.sound.play()
						this.readedTs = Date.now()
						this.readedCode = decodedText
						this.resultRead(decodedText)
					}

					// this.readedResult = decodedText
				},
				(errorMessage) => {

				}
			)
				.then(() => {
					this.showCamera = true
				})
				.catch((err) => {

				})
		},
		stopCamera() {
			this.html5QrCode?.stop().then((ignore) => {
				this.readedCode = ''
				this.showCamera = false
			}).catch((err) => {
			})
		},
		resumCamera() {
			this.html5QrCode.resume()
			this.readedCode = ''
		},
		resultRead(decoded) {
			// this.html5QrCode.pause()
			this.$emit('result', decoded)
		}
	}
}
</script>
	
<style scoped>
.scaner-wrapper {
	display: grid;
	grid-template-columns: [setting-start camera-start result-start] 1fr [setting-end camera-end result-end];
	grid-template-rows: [setting-start] auto [setting-end camera-start] 1fr [result-start] 120px [camera-end result-end];
	gap: 5px;
	/* row-gap: 5px; */
	height: 100%;
}

.setting-row {
	grid-area: setting;
}

.setting-row,
.gui-row {
	width: 100%;
	display: grid;
	grid-template-columns: [cell-start] 1fr [cell-1] 1fr [cell-2] 1fr [cell-3] 1fr [cell-end];
	grid-template-rows: 1fr;
	gap: 5px;
}

.camera-row {
	grid-area: camera;
}

.result-row {
	z-index: 100;
	grid-area: result;
}

.start-cell {
	grid-column-start: cell-start;
	grid-column-end: cell-2;
}

.start-cell>* {
	max-width: 100%;
}

.end-cell {
	grid-column-start: cell-2;
	grid-column-end: cell-end;
}

.full-cell {
	grid-column-start: cell-start;
	grid-column-end: cell-end;
}

.middle-cell {
	grid-column-start: cell-1;
	grid-column-end: cell-3;
}

.result-row {
	padding: 5px;
}

.result-wrapper {
	display: flex;
	align-items: center;
	width: 100%;
	height: 100%;
	padding: 10px;
	background: rgba(255, 255, 255, .75);
}
</style>